<mat-dialog-content>
  <div *ngIf="data.iconType === 'Danger'" class="dialog-icon">
    <mat-icon class="icon-danger">error_outline</mat-icon>
  </div>
  <div *ngIf="data.iconType === 'Warning'" class="dialog-icon">
    <mat-icon class="icon-warn">warning</mat-icon>
  </div>
  <div *ngIf="data.iconType === 'Success'" class="dialog-icon">
    <mat-icon class="icon-success" svgIcon="neo_approved"></mat-icon>
  </div>
  <div *ngIf="data.iconType === 'Information'" class="dialog-icon">
    <mat-icon class="icon-info">info</mat-icon>
  </div>
  <div *ngIf="data.iconType === 'Trash'" class="dialog-icon">
    <mat-icon svgIcon="custom_delete"></mat-icon> <!-- or use standard 'delete' -->
  </div>
  <div class="container">
    <div class="header">
      <p class="mat-headline-6">{{data.heading}}</p>
    </div>
    <br />
    <div class="content" [innerHTML]="subHeadingContent">
    </div>
  </div>
</mat-dialog-content>
<mat-toolbar class="footer">
    <mat-dialog-actions class="footer-action-buttons-container">
        <neo-button [mat-dialog-close]="false" data-set="cancelcomfirm" [text]="data.cancelButtonText" buttonType="secondary" type="button"></neo-button>
        <neo-button [mat-dialog-close]="1" [text]="data.confirmButtonText" cdkFocusInitial [buttonType]="data.confirmButtonType" type="button"
          [style]="data.splitConfirmButton ? { 'border-top-right-radius': '0', 'border-bottom-right-radius': '0' } : undefined">
        </neo-button>
        <button *ngIf="data.splitConfirmButton" mat-raised-button color="primary" class="split-button-right" [matMenuTriggerFor]="menu">
          <mat-icon aria-hidden="false">expand_more</mat-icon>
        </button>

        <mat-menu #menu="matMenu" xPosition="before" class="split-button-item">
          <button mat-menu-item [mat-dialog-close]="2">{{ data.splitConfirmButtonText }}</button>
        </mat-menu>
    </mat-dialog-actions>
</mat-toolbar>
